import BlazeSecondName from './BlazeSecondName';

export default BlazeSecondName;
